import React from 'react';
import Steps from './Steps';
import './styles/main.scss';

export const Flow = ({ json }) => {
  return <Steps {...json} />;
};

export default Flow;
